import {Component, OnInit} from '@angular/core';
import {Master} from '../../../../../admin/models/master.interface';
import {KfChartsService} from '../../../../services/kf-charts.service';
import {ChartsSearchInterface} from '../../../../models/charts-search.interface';
import {CountryChartData} from '../../../../models/country-chart-data.interface';
import {ActivatedRoute, Router} from '@angular/router';
import {buildQueryParams, getFiltersFromQueryParams} from '../../../../utils/filters-utils';

@Component({
  selector: 'app-country-vs-wf-chart',
  templateUrl: './country-vs-wf-chart.component.html',
  styleUrls: ['./country-vs-wf-chart.component.scss']
})
export class CountryVsWfChartComponent implements OnInit {

  text = 'Country vs. WEEE Forum systems';
  subtitle = '';
  data!: CountryChartData[];
  displayUnits = 'ABSOLUTE';
  years!: number[];
  categories!: Master[];
  country!: boolean;
  countryCategory!: string;
  countryCodes!: string[];

  constructor(private readonly kfChartsService: KfChartsService,
              private readonly router: Router,
              private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    if (this.router.url.includes('putonmarket')) {
      this.countryCategory = 'putonmarket';
      this.text = 'Put on market - ' + this.text;
      this.kfChartsService.getPomCategories().subscribe(data => this.categories = data);
    }
    if (this.router.url.includes('collected')) {
      this.countryCategory = 'collected';
      this.text = 'Collection - ' + this.text;
      this.kfChartsService.getCollectionStreams().subscribe(data => this.categories = data);
    }
    this.country = this.router.url.includes('/country/');
    this.activatedRoute.queryParams.subscribe((params) => {
      const search = getFiltersFromQueryParams(params);

      this.kfChartsService.getYears(this.countryCategory, 'COUNTRY_SCHEMA', search.categoryType ? search.categoryType : 'NEW')
        .subscribe(data => {
          this.years = data;
          if (!search.startYear) {
            search.startYear = data[0];
          }
          if (!search.categoryType) {
            search.categoryType = 'NEW';
          }
          if (!search.displayUnits) {
            search.displayUnits = 'ABSOLUTE';
          }
          this.subtitle = search.startYear + ' (tons)';
          this.kfChartsService.getCountryVsWF(search, this.countryCategory)
            .subscribe(response => {
            this.data = response;
          });
          this.kfChartsService.getCountryVsWFCountries(search, this.countryCategory)
            .subscribe(response => {
            this.countryCodes = response;
          });
        });
    });
  }

  searchData(event: ChartsSearchInterface): void {
    this.router.navigate([this.router.url.split('?')[0]], {queryParams: buildQueryParams(event)});

    if (event.displayUnits && event.displayUnits !== '') {
      this.displayUnits = event.displayUnits;
    }
  }

  loadCategories(event: string): void {
    if (event === 'OLD') {
      this.kfChartsService.getOldPomCategories().subscribe(data => this.categories = data);
    } else {
      this.kfChartsService.getPomCategories().subscribe(data => this.categories = data);
    }
    this.kfChartsService.getYears(this.countryCategory, 'COUNTRY_SCHEMA', event)
      .subscribe(data => this.years = data);
  }

}
